import React, { useEffect, useState, useContext } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from "../../shared/context/auth-context";
import ToastError from "../../shared/elements/ToastError";
import PendingVideosSection from "../components/PendingVideosSection";
import RecentVideosSection from "../components/RecentVideosSection";
import ViewContentSection from "../components/ViewContentSection";
import styles from "./Dashboard.module.css";

const Dashboard = () => {
	// Credit Balance functionality
	const { isLoading, error, sendRequest, clearError } = useHttpClient();
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [videoData, setVideoData] = useState([]);

	useEffect(() => {
		const fetchVideos = async () => {
			try {
				const response = await sendRequest(
					`/api/videos`,
					"GET",
					null,
					{
						Authorization: "Bearer " + authContext.token,
					}
				);
				if (response.data) {
					setVideoData(response.data);
				}
			} catch (err) {
				console.error("Error fetching videos:", err);
			}
		}
		fetchVideos();
	}, [sendRequest, authContext.token]);

	// New Video Card functionality
	const handleStartNewVideo = () => {
		navigate("/start-new-video");
	};

	return (
		<div className="dashboard-container" data-tour-target="dashboard">
			{/* Dashboard Header */}
			<ToastError
				show={!!error}
				onClose={clearError}
				message={error}
				isLoading={isLoading}
			/>
			<h1 className={styles.header}>
				Welcome back{(authContext.firstName ? `, ${authContext.firstName}` : "")}
			</h1>

			{/* New Video Card */}
			<div className={styles.card}>
				<div className={styles.content}>
					<h5 className={styles.title}>Generate a new video</h5>
					<p className={styles.description}>Click the button to the right to generate a new video.</p>
				</div>
				<Button 
					variant="primary" 
					onClick={handleStartNewVideo}
					className={styles.button}
				>
					Start New Video
				</Button>
			</div>

			{/* Other Dashboard Sections */}
			<PendingVideosSection />
			<RecentVideosSection
				videoData={videoData}
			/>
			<ViewContentSection
				videoData={videoData}
			/>
		</div>
	);
};

export default Dashboard;
